<!--<style [attr.id]="dynamicStyles2" id="dynamicStyles">
  .abx-element:not(.selected-element):hover {
    border-width: 2px !important;
  }

  .selected-element {
    border-width: 5px !important;
  }
</style>-->
<div *ngIf="isImageLoaded" [attr.inert]="beInert()" (click)="handlePageClick(undefined)" (contextmenu)="handlePageClick(undefined)">
  <input type="file" id="imageSignature" accept="image/jpeg,image/png" class="d-none" />
  <div id="toolbar" class="toolbar" [hidden]="!(pageIsPositioned && pageIsLoaded)">

    <!-- Primary toolbar-->
    <div class="toolbar-top-primary">

      <!-- NO SELECTION - INSERT NEW ELEMENT -->
      <!-- INPUT TOOLS -->
      <div [hidden]="(cropActive)" class="btn-group d-none d-md-inline-block d-lg-inline-block">
        <!-- Tools -->
        <button class="btn btn-default {{ (mode == MODE_IDLE ? 'btn-highlight' : '') }}" (click)="$event.stopPropagation(); $event.preventDefault(); addPenMarker(penMakerPoints, mode); onCursorBtnClicked();" title="{{'Select' | translate}}"><i class="toolbar-icon ic-cursor"></i><span class="d-none d-xl-inline-block"> {{'Select' | translate}}</span></button>
        <button class="btn btn-default {{ (mode == MODE_INSERTING_TEXT ? 'btn-highlight' : '') }}" (click)="addPenMarker(penMakerPoints, mode); onInsertTextBtnClicked();" title="{{'Text' | translate}}"><i class="toolbar-icon ic-text"></i><span class="d-none d-xl-inline-block"> {{'Text' | translate}}</span></button>
        <button class="btn btn-default {{ (mode == MODE_INSERTING_PEN_START || mode == MODE_INSERTING_PEN ? 'btn-highlight' : '') }}" (click)="addPenMarker(penMakerPoints, mode); openCanvasEditor(3)" title="{{'Pencil' | translate}}"><i class="toolbar-icon ic-pencil"></i><span class="d-none d-xl-inline-block">  {{'Pencil' | translate}}</span></button>
        <button class="btn btn-default {{ (mode == MODE_INSERTING_MARKER_START || mode == MODE_INSERTING_MARKER ? 'btn-highlight' : '') }}" (click)="addPenMarker(penMakerPoints, mode); openCanvasEditor(4)" title="{{'Marker' | translate}}"><i class="toolbar-icon ic-marker"></i><span class="d-none d-xl-inline-block">  {{'Marker' | translate}}</span></button>
        <button class="btn btn-default {{ (mode == MODE_ERASING ? 'btn-highlight' : '') }}" (click)="addPenMarker(penMakerPoints, mode); openEraser(true)" title="{{'Eraser' | translate}}"><i class="toolbar-icon ic-eraser"></i><span class="d-none d-xl-inline-block"> {{'Eraser' | translate}}</span></button>
        <button class="btn btn-default" (click)="addPenMarker(penMakerPoints, mode); chooseImageToInsert()" title="{{'InsertImage' | translate}}"><i class="toolbar-icon ic-insert-image"></i><span class="d-none d-xl-inline-block"> {{'InsertImage' | translate}}</span></button>
      </div>

      <!-- INPUT TOOLS for mobile -->
      <div [hidden]="(cropActive)" class="btn-group dropdown d-xs-inline-block d-sm-inline-block d-md-none d-lg-none d-xl-none">
        <button class="btn btn-default dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="true" title="{{'Tools' | translate}}">
          <i class="toolbar-icon ic-tools"></i>
        </button>
        <ul class="dropdown-menu dropdown-menu-max-mobile-height-480">
          <li class="{{ (mode == MODE_IDLE ? 'btn-highlight' : '') }}"><a class="dropdown-item" href="javascript:void(0)" (click)="addPenMarker(penMakerPoints, mode);onCursorBtnClicked();"><i class="toolbar-icon ic-cursor"></i> {{'Select' | translate}}</a></li>
          <li class="{{ (mode == MODE_INSERTING_TEXT ? 'btn-highlight' : '') }}"><a class="dropdown-item" href="javascript:void(0)" (click)="addPenMarker(penMakerPoints, mode);onInsertTextBtnClicked();"><i class="toolbar-icon ic-text"></i> {{'Text' | translate}}</a></li>
          <li class="{{ (mode == MODE_INSERTING_PEN_START || mode == MODE_INSERTING_PEN ? 'btn-highlight' : '') }}"><a class="dropdown-item" href="javascript:void(0)" (click)="addPenMarker(penMakerPoints, mode);openCanvasEditor(3)"><i class="toolbar-icon ic-pencil"></i> {{'Pencil' | translate}}</a></li>
          <li class="{{ (mode == MODE_INSERTING_MARKER_START || mode == MODE_INSERTING_MARKER ? 'btn-highlight' : '') }}"><a class="dropdown-item" href="javascript:void(0)" (click)="addPenMarker(penMakerPoints, mode);openCanvasEditor(4)"><i class="toolbar-icon ic-marker"></i> {{'Marker' | translate}}</a></li>
          <li class="{{ (mode == MODE_ERASING ? 'btn-highlight' : '') }}"><a class="dropdown-item" href="javascript:void(0)" (click)="addPenMarker(penMakerPoints, mode);openEraser(true)"><i class="toolbar-icon ic-eraser"></i> {{'Eraser' | translate}}</a></li>
          <li><a class="dropdown-item" href="javascript:void(0)" (click)="addPenMarker(penMakerPoints, mode);chooseImageToInsert()"><i class="toolbar-icon ic-insert-image"></i> {{'InsertImage' | translate}}</a></li>
          <li role="separator" class="divider"></li>
          <li><a class="dropdown-item" href="javascript:void(0)" (click)="addPenMarker(penMakerPoints, mode);stopEditingAndExecFilter('grayscale');" *ngIf="!grayscale"><i class="toolbar-icon ic-grayscale"></i> {{'Grayscale' | translate}}</a></li>
          <li><a class="dropdown-item" href="javascript:void(0)" (click)="addPenMarker(penMakerPoints, mode);stopEditingAndExecFilter('normalize');"><i class="toolbar-icon ic-enhance"></i> {{'Contrast' | translate}}</a></li>
          <li><a class="dropdown-item" href="javascript:void(0)" (click)="addPenMarker(penMakerPoints, mode);stopEditingAndExecFilter('crop');"><i class="toolbar-icon ic-crop"></i> {{'Crop' | translate}}</a></li>
          <li><a class="dropdown-item" href="javascript:void(0)" (click)="addPenMarker(penMakerPoints, mode);stopEditingAndExecFilter('rotate');"><i class="toolbar-icon ic-rotate"></i> {{'Rotate' | translate}}</a></li>
        </ul>
      </div>

      <!-- SIGNATURE -->
      <div [hidden]="(cropActive)" class="btn-group dropdown" ngbDropdown id="signatures-toolbar" (click)="addPenMarker(penMakerPoints, mode);stopEditingCurrentElement();">
        <!-- Signature -->
        <button class="btn btn-default" (click)="checkUserAndOpenSignatureDialog()" [hidden]="(userId)" [ngClass]="{'ng-hide': (userId)}" title="{{'Signature' | translate}}"><i class="toolbar-icon ic-signature-pen"></i><span class="d-none d-xl-inline-block"> {{'Signature' |translate}}</span></button>
        <button class="btn btn-default dropdown-toggle" ngbDropdownToggle type="button" id="dropdownMenuSignature" aria-expanded="true" (click)="loadSignatures()" title="{{'Signature' | translate}}" [hidden]="!(userId)" [ngClass]="{'ng-hide': !(userId)}">
          <i class="toolbar-icon ic-signature-pen"></i><span class="d-none d-xl-inline-block">  {{ 'Signature' | translate }}</span>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownMenuSignature" class="dropdown-menu dropdown-menu-max-mobile-height-480">
          <div ngbDropdownItem *ngIf="isLoadingSignatures()" class="loading-signatures-wrapper">
            <div class="loader-centered-small"></div>
          </div>
          <table ngbDropdownItem class="table table-no-borders signatures-list dropdown-item-none-hover" *ngIf="!isLoadingSignatures()">
            <tbody>
              <tr *ngFor="let item of savedSignatures; index as i">
                <td (click)="loadSignature(item.id)" class="table-cell-selectable" width="90%">
                  <span *ngIf="item.data?.elementIdentificator === 8">
                    <img draggable="false" *ngIf="item.data.type===0" data-src="data:image/png;base64,{{item.data.image}}" class="img-signature" />
                    <img draggable="false" *ngIf="item.data.type===1" data-src="data:image/jpeg;base64,{{item.data.image}}" class="img-signature" />
                  </span>
                  <span *ngIf="item.data?.elementIdentificator !== 8">
                    <app-pen-marker class="noselect"
                                    [element]="item.data"
                                    [draggable]="false"
                                    [pageElement]="false"
                                    [maxWidth]="150"
                                    [maxHeight]="50"></app-pen-marker>
                  </span>
                </td>
                <td class="table-cell-nopadding align-center" width="10%">
                  <span *ngIf="item.deleting" class="loader-centered-small d-inline-block"></span>
                  <div *ngIf="!item.deleting" title="{{'Delete' | translate}}" class="btn-small-delete" (click)="deleteSignature(item); $event.stopPropagation();"></div>
                </td>
              </tr>
              <tr *ngIf="savedSignatures?.length < 3" class="{{ (savedSignatures?.length > 0 ? 'tr-menu-upper-border' : '') }}">
                <td (click)="addNewSignature()">
                  <span>{{ 'AddSignature' | translate }}</span>
                </td>
                <td (click)="addNewSignature()">
                  <div title="{{'AddSignature' | translate}}" class="btn-small-add"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- DELETE & INSERT PAGES for mobile -->
      <div class="btn-group dropdown d-xs-inline-block d-sm-inline-block d-md-none d-lg-none d-xl-none" *ngIf="!clientMode && !cropActive && !selectedObj && mode == MODE_IDLE">
        <button class="btn btn-default" title="{{'DeletePage' | translate}}" *ngIf="!clientMode" [disabled]="!(prevPage || nextPage)" (click)="askDeletePage()"><i class="toolbar-icon ic-page-delete"></i></button>
        <button class="btn btn-default" title="{{'InsertPages' | translate}}" *ngIf="!clientMode" (click)="insertPage()"><i class="toolbar-icon ic-page-add"></i></button>
      </div>

      <!-- ENHANCE IMAGE -->
      <div class="btn-group d-none d-md-inline-block d-lg-inline-block" *ngIf="!cropActive && !selectedObj && mode == MODE_IDLE">
        <button class="btn btn-default" (click)="addPenMarker(penMakerPoints, mode);stopEditingAndExecFilter('grayscale')" title="{{'Grayscale' | translate}}" *ngIf="!grayscale"><i class="toolbar-icon ic-grayscale"></i><span class="d-none d-xxl-inline-block"> {{'Grayscale' | translate}}</span></button>
        <button class="btn btn-default" (click)="addPenMarker(penMakerPoints, mode);stopEditingAndExecFilter('normalize')" title="{{'Contrast' | translate}}"><i class="toolbar-icon ic-enhance"></i><span class="d-none d-xxl-inline-block"> {{'Contrast' | translate}}</span></button>
        <button class="btn btn-default" (click)="addPenMarker(penMakerPoints, mode);stopEditingAndExecFilter('crop')" title="{{'Crop' | translate}}"><i class="toolbar-icon ic-crop"></i><span class="d-none d-xxl-inline-block"> {{'Crop' | translate}}</span></button>
        <button class="btn btn-default" (click)="addPenMarker(penMakerPoints, mode);stopEditingAndExecFilter('rotate')" title="{{'Rotate' | translate}}"><i class="toolbar-icon ic-rotate"></i><span class="d-none d-xxl-inline-block"> {{'Rotate' |translate}}</span></button>
      </div>

      <!-- SELECTED PEN/MARKER -->
      <div [hidden]="!(!cropActive && selectedMarker !== undefined && selectedMarker?.elementIdentificator !== 7)" class="btn-group d-inline-block">

        <!-- Colors for PEN -->
        <div *ngIf="selectedMarker?.elementIdentificator===3 && !grayscale" ngbDropdown class="dropdown d-inline-block">
          <div>
            <button class="btn btn-default dropdown-toggle" ngbDropdownToggle type="button" id="dropdownMenuColor1" aria-expanded="true" title="{{'Color' | translate}}">
              <i class="toolbar-icon ic-colors-pen"></i><div class="d-none d-md-inline-block d-lg-inline-block"> {{'Color' | translate}} <span class="caret"></span></div>
            </button>
            <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="dropdownMenuColor1">
              <li><a ngbDropdownItem href="javascript:void(0)" (click)="markerColor('0x000000')"><span class="col-button col-button-black"></span> {{'hBlack' | translate}}</a></li>
              <li><a ngbDropdownItem href="javascript:void(0)" (click)="markerColor('0xFF0000')"><span class="col-button col-button-red"></span> {{'hRed' | translate}}</a></li>
              <li><a ngbDropdownItem href="javascript:void(0)" (click)="markerColor('0x0000FF')"><span class="col-button col-button-blue"></span> {{'hBlue' | translate}}</a></li>
            </ul>
          </div>
        </div>

        <!-- Colors for MARKER -->
        <div *ngIf="selectedMarker?.elementIdentificator===4 && !grayscale" ngbDropdown class="dropdown d-inline-block">
          <div>
            <button class="btn btn-default dropdown-toggle" ngbDropdownToggle type="button" id="dropdownMenuColor2" aria-expanded="true" title="{{'Color' | translate}}">
              <i class="toolbar-icon ic-colors-marker"></i><div class="d-none d-md-inline-block d-lg-inline-block"> {{'Color' | translate}} <span class="caret"></span></div>
            </button>
            <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="dropdownMenuColor2">
              <li><a ngbDropdownItem href="javascript:void(0)" (click)="markerColor('0x00FF00')"><span class="col-button col-button-green"></span> {{'hGreen' | translate}}</a></li>
              <li><a ngbDropdownItem href="javascript:void(0)" (click)="markerColor('0xFFFF00')"><span class="col-button col-button-yellow"></span> {{'hYellow' | translate}}</a></li>
              <li><a ngbDropdownItem href="javascript:void(0)" (click)="markerColor('0xFF00FF')"><span class="col-button col-button-purple"></span> {{'hPurple' | translate}}</a></li>
            </ul>
          </div>
        </div>

        <!-- Pen/Marker width -->
        <div class="dropdown d-inline-block" ngbDropdown>
          <button class="btn btn-default dropdown-toggle" ngbDropdownToggle type="button" id="dropdownMenuLineWeight" aria-expanded="true" title="{{'LineWeight' | translate}}">
            <i class="toolbar-icon ic-line-weight"></i><div class="d-none d-md-inline-block d-lg-inline-block">{{'LineWeight' | translate}} <span class="caret"></span></div>
          </button>
          <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="dropdownMenuLineWeight">
            <div class="lineWidthRangeContainer">
              <!-- Input for PEN -->
              <input ngbDropdownItem *ngIf="selectedMarker?.elementIdentificator===3" type="range" min="1" max="100" [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedMarkerInkSize" (ngModelChange)="markerLineWidthAbs(selectedMarkerInkSize)" class="lineWidthRange" id="lineWidthRange" />
              <!-- Input for MARKER -->
              <input ngbDropdownItem *ngIf="selectedMarker?.elementIdentificator===4" type="range" min="1" max="250" [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedMarkerInkSize" (ngModelChange)="markerLineWidthAbs(selectedMarkerInkSize)" class="lineWidthRange" id="lineWidthRange" />
              <img ngbDropdownItem src="./images/icons/ic_line_weight_slider.svg" class="lineWidthRangeIndicator" />
            </div>
          </div>
        </div>

        <!-- Delete -->
        <div class="d-inline-block">
          <button title="{{'Delete' | translate}}" class="btn btn-default" (click)="markerDelete()"><i class="toolbar-icon ic-delete" title="{{'Delete' | translate}}"></i></button>
        </div>

      </div>

      <!-- SELECTED MARKER -->
      <div [hidden]="!(!cropActive && selectedMarker !== undefined && selectedMarker?.elementIdentificator===7)" class="d-inline-block">
        <div class="btn-group">
          <button (click)="markerLineWidth(1)" class="btn btn-default" title="{{'SignatureIncrease' | translate}}"><i class="toolbar-icon ic-plus"></i></button>
          <button (click)="markerLineWidth(-1)" class="btn btn-default" title="{{'SignatureDecrease' | translate}}"><i class="toolbar-icon ic-minus"></i></button>
        </div>
        <button title="{{'Delete' | translate}}" class="btn btn-default" (click)="markerDelete()"><i class="toolbar-icon ic-delete"></i></button>
      </div>

      <!-- SELECTED IMAGE SIGNATURE -->
      <div [hidden]="!(!cropActive && selectedImgSignature !== undefined)" class="d-inline-block">
        <div class="btn-group">
          <button (click)="imageSigScale(1)" class="btn btn-default" title="{{'SignatureIncrease' | translate}}"><i class="toolbar-icon ic-plus"></i></button>
          <button (click)="imageSigScale(-1)" class="btn btn-default" title="{{'SignatureDecrease' | translate}}"><i class="toolbar-icon ic-minus"></i></button>
        </div>
        <button title="{{'Delete' | translate}}" class="btn btn-default" (click)="imageSigDelete()"><i class="toolbar-icon ic-delete"></i></button>
      </div>

      <!-- SELECTED TEXT -->
      <div [hidden]="!(!cropActive && selectedText !== undefined)" class="btn-group d-inline-block">

        <div ngbDropdown class="dropdown d-inline-block">
          <button ngbDropdownToggle class="btn btn-default dropdown-toggle" type="button" id="dropdownMenuFontStyle" aria-expanded="true" title="{{'FontStyle' | translate}}">
            <i class="toolbar-icon ic-font-style"></i><div class="d-none d-md-inline-block d-lg-inline-block"><span class="d-none d-xl-inline-block">{{'FontStyle' | translate}} <span class="caret"></span></span></div>
          </button>
          <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="dropdownMenuFontStyle">
            <li><a ngbDropdownItem href="javascript:void(0)" [hidden]="!(selectedText?.letterSpacing === 0)" (click)="changeFontName('0')"><app-checkbox [checkboxType]="'circle'" [value]="selectedText?.font" [onValue]="'0'"></app-checkbox> <span class="abx-monospace">Monospace</span></a></li>
            <li><a ngbDropdownItem href="javascript:void(0)" [hidden]="!(selectedText?.letterSpacing === 0)" (click)="changeFontName('1')"><app-checkbox [checkboxType]="'circle'" [value]="selectedText?.font" [onValue]="'1'"></app-checkbox> <span class="abx-serif">Serif</span></a></li>
            <li><a ngbDropdownItem href="javascript:void(0)" [hidden]="!(selectedText?.letterSpacing === 0)" (click)="changeFontName('2')"><app-checkbox [checkboxType]="'circle'" [value]="selectedText?.font" [onValue]="'2'"></app-checkbox> <span class="abx-sans-serif">Sans-serif</span></a></li>
            <li role="separator" class="divider" [hidden]="!(selectedText?.letterSpacing === 0)"></li>
            <li><a ngbDropdownItem href="javascript:void(0)" (click)="changeFontStyle(1-selectedText?.bold, -1)"><app-checkbox [checkboxType]="'box'" [value]="selectedText?.bold" [onValue]="1"></app-checkbox> <b>{{'Bold' | translate}}</b></a></li>
            <li><a ngbDropdownItem href="javascript:void(0)" (click)="changeFontStyle(-1, 1-selectedText?.italic)"><app-checkbox [checkboxType]="'box'" [value]="selectedText?.italic" [onValue]="1"></app-checkbox> <i>{{'Italic' | translate}}</i></a></li>
            <li role="separator" class="divider" *ngIf="!grayscale"></li>
            <li>
              <a ngbDropdownItem href="javascript:void(0)" (click)="textColor('0xFF000000')" *ngIf="!grayscale"><div class="col-button col-button-black"></div> {{'black' | translate}}</a>
            </li>
            <li>
              <a ngbDropdownItem href="javascript:void(0)" (click)="textColor('0xFFFFFF00')" *ngIf="!grayscale"><div class="col-button col-button-yellow"></div> {{'yellow' | translate}}</a>
            </li>
            <li>
              <a ngbDropdownItem href="javascript:void(0)" (click)="textColor('0xFFFF0000')" *ngIf="!grayscale"><div class="col-button col-button-red"></div> {{'red' | translate}}</a>
            </li>
            <li>
              <a ngbDropdownItem href="javascript:void(0)" (click)="textColor('0xFF00FF00')" *ngIf="!grayscale"><div class="col-button col-button-green"></div> {{'green' | translate}}</a>
            </li>
            <li>
              <a ngbDropdownItem href="javascript:void(0)" (click)="textColor('0xFF0000FF')" *ngIf="!grayscale"><div class="col-button col-button-blue"></div> {{'blue' | translate}}</a>
            </li>
          </ul>
        </div>

        <!-- Increase/decrese font size -->
        <div class="d-none d-md-inline-block d-lg-inline-block">
          <button (click)="textFontSize(1)" class="btn btn-default" title="{{'FontIncrease' | translate}}"><i class="toolbar-icon ic-font-increase"></i></button>
          <button (click)="textFontSize(-1)" class="btn btn-default" title="{{'FontDecrease' | translate}}"><i class="toolbar-icon ic-font-decrease"></i></button>
        </div>

        <!-- Increase/decrese font letter spacing -->
        <div class="d-none d-md-inline-block d-lg-inline-block">
          <button *ngIf="selectedText?.letterSpacing === 0" (click)="activateLetterSpacing()" class="btn btn-default" title="{{'ActivateLetterSpacing' | translate}}"><i class="toolbar-icon ic-font-activate-letter-spacing"></i></button>
          <button *ngIf="selectedText?.letterSpacing !== 0" (click)="deactivateLetterSpacing()" class="btn btn-default" title="{{'DeactivateLetterSpacing' | translate}}"><i class="toolbar-icon ic-font-deactivate-letter-spacing"></i></button>
        </div>

        <!-- Delete -->
        <div class="d-inline-block">
          <button (click)="deleteSelection(); stopEditingCurrentElement();" class="btn btn-default" title="{{'Delete' | translate}}"><i class="toolbar-icon ic-delete"></i></button>
        </div>
      </div>

      <!-- CANVAS EDITOR -->
      <div class="btn-group d-inline-block" [hidden]="!(!cropActive && (mode === MODE_INSERTING_PEN || mode === MODE_INSERTING_MARKER || mode === MODE_INSERTING_SIGNATURE_PEN))">

        <!-- Colors for PEN -->
        <div *ngIf="mode === MODE_INSERTING_PEN && !grayscale" ngbDropdown class="dropdown d-inline-block">
          <div>
            <button class="btn btn-default dropdown-toggle" ngbDropdownToggle type="button" id="dropdownMenuColor1" aria-expanded="true" title="{{'Color' | translate}}">
              <i class="toolbar-icon ic-colors-pen"></i><div class="d-none d-md-inline-block d-lg-inline-block"><span class="d-lg-inline-block">{{'Color' | translate}} <span class="caret"></span></span></div>
            </button>
            <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="dropdownMenuColor1">
              <li><a ngbDropdownItem href="javascript:void(0)" (click)="canvasColor('0x000000')"><span class="col-button col-button-black"></span> {{'hBlack' | translate}}</a></li>
              <li><a ngbDropdownItem href="javascript:void(0)" (click)="canvasColor('0xFF0000')"><span class="col-button col-button-red"></span> {{'hRed' | translate}}</a></li>
              <li><a ngbDropdownItem href="javascript:void(0)" (click)="canvasColor('0x0000FF')"><span class="col-button col-button-blue"></span> {{'hBlue' | translate}}</a></li>
            </ul>
          </div>
        </div>

        <!-- Colors for MARKER -->
        <div *ngIf="mode === MODE_INSERTING_MARKER && !grayscale" ngbDropdown class="dropdown d-inline-block">
          <div>
            <button class="btn btn-default dropdown-toggle" ngbDropdownToggle type="button" id="dropdownMenuColor2" aria-expanded="true" title="{{'Color' | translate}}">
              <i class="toolbar-icon ic-colors-marker"></i><div class="d-none d-md-inline-block d-lg-inline-block"><span class="d-none d-xl-inline-block">{{'Color' | translate}} <span class="caret"></span></span></div>
            </button>
            <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="dropdownMenuColor2">
              <li><a ngbDropdownItem href="javascript:void(0)" (click)="canvasColor('0x00FF00')"><span class="col-button col-button-green"></span> {{'hGreen' | translate}}</a></li>
              <li><a ngbDropdownItem href="javascript:void(0)" (click)="canvasColor('0xFFFF00')"><span class="col-button col-button-yellow"></span> {{'hYellow' | translate}}</a></li>
              <li><a ngbDropdownItem href="javascript:void(0)" (click)="canvasColor('0xFF00FF')"><span class="col-button col-button-purple"></span> {{'hPurple' | translate}}</a></li>
            </ul>
          </div>
        </div>

        <!-- Pen/Marker width -->
        <div *ngIf="mode !== MODE_INSERTING_SIGNATURE_PEN" ngbDropdown class="dropdown d-inline-block">
          <button class="btn btn-default dropdown-toggle" ngbDropdownToggle type="button" id="dropdownMenuLineWeight" aria-expanded="true" title="{{'LineWeight' | translate}}">
            <i class="toolbar-icon ic-line-weight"></i><div class="d-none d-md-inline-block d-lg-inline-block"><span class="d-none d-xl-inline-block">{{'LineWeight' | translate}} <span class="caret"></span></span></div>
          </button>
          <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="dropdownMenuLineWeight">
            <div class="lineWidthRangeContainer">
              <!-- Input for PEN -->
              <input ngbDropdownItem *ngIf="mode === MODE_INSERTING_PEN" type="range" min="1" max="100" [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedMarkerInkSize" (ngModelChange)="canvasLineWidthAbs(selectedMarkerInkSize)" class="lineWidthRange" id="lineWidthRange" />
              <!-- Input for MARKER -->
              <input ngbDropdownItem *ngIf="mode === MODE_INSERTING_MARKER" type="range" min="1" max="250" [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedMarkerInkSize" (ngModelChange)="canvasLineWidthAbs(selectedMarkerInkSize)" class="lineWidthRange" id="lineWidthRange" />
              <img ngbDropdownItem src="./images/icons/ic_line_weight_slider.svg" class="lineWidthRangeIndicator" />
            </div>
          </div>
        </div>

        <!-- Delete -->
        <div class="d-inline-block">
          <button class="btn btn-default" title="{{ 'Delete' | translate }}" (click)="cancelCanvasEditor(); stopEditingCurrentElement();"><i class="toolbar-icon ic-delete"></i></button>
        </div>

      </div>

      <!-- UNDO -->
      <div class="btn-group d-none d-inline-block" [hidden]="!(!cropActive && undoAction != UNDO_ACTION_NONE)">
        <button class="btn btn-default" *ngIf="undoAction == UNDO_ACTION_ERASER" (click)="revertEraser()" title="{{'RevertEraser' | translate}}"><i class="toolbar-icon ic-undo"></i><span class="d-none d-xl-inline-block"> {{'RevertEraser' | translate}}</span></button>
        <button class="btn btn-default" *ngIf="undoAction == UNDO_ACTION_GRAYSCALE" (click)="applyImageFilter('original')" title="{{'RevertGrayscale' | translate}}"><i class="toolbar-icon ic-undo"></i><span class="d-none d-xl-inline-block"> {{'RevertGrayscale' | translate}}</span></button>
        <button class="btn btn-default" *ngIf="undoAction == UNDO_ACTION_CONTRAST" (click)="applyImageFilter('original')" title="{{'RevertContrast' | translate}}"><i class="toolbar-icon ic-undo"></i><span class="d-none d-xl-inline-block"> {{'RevertContrast' | translate}}</span></button>
        <button class="btn btn-default" *ngIf="undoAction == UNDO_ACTION_CROP" (click)="applyImageFilter('original')" title="{{'RevertCrop' | translate}}"><i class="toolbar-icon ic-undo"></i><span class="d-none d-xl-inline-block"> {{'RevertCrop' | translate}}</span></button>
        <button class="btn btn-default" *ngIf="undoAction == UNDO_ACTION_RCW" (click)="applyImageFilter('original')" title="{{'RevertRotate' | translate}}"><i class="toolbar-icon ic-undo"></i><span class="d-none d-xl-inline-block"> {{'RevertRotate' | translate}}</span></button>
      </div>

      <!-- CROP TOOL -->
      <div [hidden]="!(cropActive)">
        <button class="btn btn-default" (click)="cancelCrop()" title="{{ 'Cancel' | translate }}"><i class="toolbar-icon ic-cancel"></i></button>
        <button class="btn btn-default" (click)="cropBackground()" title="{{ 'Crop' | translate }}"><i class="toolbar-icon ic-ok"></i></button>
      </div>
    </div>

    <!-- Secondary toolbar-->
    <div class="toolbar-top-secondary" [hidden]="!(!cropActive)">
      <div class="btn-group btn-group-left-border" *ngIf="!clientMode">
        <button title="{{'Save' | translate}}" (click)="addPenMarker(penMakerPoints, mode); saveAndDownload('swrd')" class="btn btn-default"><i class="toolbar-icon ic-save"></i><span class="unsaved-changes-indicator" *ngIf="didDocumentChangeSinceLastDownload()"></span></button>
        <div *ngIf="showUnsavedChangesTooltip()" class="save-tooltip">
          <div class="save-tooltip-arrow">
            <div class="arrow-up"></div>
          </div>
          <div class="save-tooltip-inner-wrapper">
            <div class="save-tooltip-content">
              <span>{{ 'Unsaved-edits' | translate }} <a href="javascript:void(0)" (click)="addPenMarker(penMakerPoints, mode); saveAndDownload('swrd')">{{ 'Unsaved-edits-download' | translate }}</a>{{ 'Unsaved-edits-to-keep-for-later' | translate }}</span>
              <span class="save-tooltip-close" (click)="closeUnsavedChangesTooltip()"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-group btn-group-left-border dropdown" ngbDropdown>
        <button title="{{'Close' | translate}}" *ngIf="clientMode && !pageModified && !documentModified" (click)="addPenMarker(penMakerPoints, mode);cancelAndContinue()" class="btn btn-default"><i class="toolbar-icon ic-cancel"></i><span class="d-none d-xl-inline-block"> <b>{{'Close' | translate}}</b></span></button>
        <button title="{{'Cancel' | translate}}" *ngIf="clientMode && (pageModified || documentModified)" (click)="addPenMarker(penMakerPoints, mode);cancelAndContinue()" class="btn btn-default"><i class="toolbar-icon ic-cancel"></i><span class="d-none d-xl-inline-block"> <b>{{'Cancel' | translate}}</b></span></button>
        <button title="{{'Save' | translate}}" *ngIf="clientMode && (pageModified || documentModified)" (click)="addPenMarker(penMakerPoints, mode); saveAndContinue(undefined)" class="btn btn-default"><i class="toolbar-icon ic-ok"></i><span class="visible-lg-inline-block"> <b>{{'Save' | translate}}</b></span></button>
        <button class="btn btn-default dropdown-toggle" ngbDropdownToggle type="button" id="dropdownMenuDownload" aria-expanded="true" title="{{'Export' | translate}}" *ngIf="!clientMode || (clientMode && showDownButton && !(pageModified || documentModified))">
          <i class="toolbar-icon ic-download"></i><div class="d-none d-xl-inline-block"> <b>{{'Download' | translate}}</b> <span class="caret"></span></div>
        </button>
        <ul class="dropdown-menu dropdown-menu-right" ngbDropdownMenu aria-labelledby="dropdownMenuDownload">
          <li class="abx-dropdown-menu-item" *ngIf="!clientMode"><a ngbDropdownItem href="javascript:void(0)" (click)="addPenMarker(penMakerPoints, mode);checkSubscriptionAndDownload('pdf', false, false, -1)">{{'DownloadPDF' | translate}}</a></li>
          <li class="abx-dropdown-menu-item" *ngIf="!clientMode"><a ngbDropdownItem href="javascript:void(0)" (click)="addPenMarker(penMakerPoints, mode);checkSubscriptionAndDownload('pdf', true, false, -1)">{{'PerformOCRAndDownloadPDF' | translate}}</a></li>
          <li class="abx-dropdown-menu-item" *ngIf="!clientMode"><a ngbDropdownItem href="javascript:void(0)" (click)="addPenMarker(penMakerPoints, mode);checkSubscriptionAndDownload('png', false, false, currentPageNo)">{{'ExportPageAsPNG' | translate}}</a></li>
          <li class="abx-dropdown-menu-item" *ngIf="!clientMode"><a ngbDropdownItem href="javascript:void(0)" (click)="addPenMarker(penMakerPoints, mode);checkSubscriptionAndDownload('pdf', false, true, -1)">{{'PrintPDF' | translate}}</a></li>
          <li class="abx-dropdown-menu-item abx-dropdown-divider" *ngIf="!clientMode"></li>
          <li class="abx-dropdown-menu-item" *ngIf="!clientMode"><a ngbDropdownItem href="javascript:void(0)" (click)="addPenMarker(penMakerPoints, mode);saveAndDownload('swrd')">{{'DownloadSWRD' | translate}}</a></li>
          <li class="abx-dropdown-menu-item" *ngIf="clientMode && showDownButton"><a ngbDropdownItem href="{{clientDownloadPDFLink}}" target="_blank">{{'DownloadPDF' | translate}}</a></li>
        </ul>
      </div>
    </div>

  </div>
</div>

<div [attr.inert]="beInert()" (click)="handlePageClick(undefined)" [ngClass]="{'extendHeightMinusToolbarClientMode': clientMode}" class="extendHeightMinusToolbar" id="page-container" style="{{ (pageIsPositioned ? 'opacity: 1.0' : 'opacity: 0.0') }}">
  <div class="pagePlaceholder" id="pagePlaceholder" (contextmenu)="handlePageClick($event)">

    <!-- PAGE -->
    <div id="page" class="page">

      <img draggable="false"
           class="backgroundImage noselect"
           ng-style="backgroundStyle"
           id="background"
           abx-drop="moveElement($abxEltId, $abxPosX, $abxPosY)"
           data-src="data:image/png;base64,{{page?.background.image}}"
           (click)="deselect($event)"
           (load)="onLoad();" />

      <div *ngIf="isImageLoaded">
        <app-canvas-editor class="editor-component"
                           *ngIf="isImageLoaded && canvasEditorOpen"
                           [ngStyle]="canvasStyle"
                           style="cursor: crosshair"
                           [active]="canvasEditorOpen"
                           [initialPoints]="penMakerPoints"
                           [backgroundId]="'background'"
                           [inkWidth]="newMarkerWidth"
                           (updatePoints)="updatePenMaketPoints($event)"
                           [inkColor]="newMarkerColor"
                           [container]="'background'"
                           [mode]="mode"
                           (abxOnDrawStart)="onCanvasDrawStart()"></app-canvas-editor>

        <app-eraser class="editor-component editor-component-eraser"
                    [ngStyle]="eraserStyle"
                    [inkWidth]="eraserInkWidth"
                    (save)="saveEraser($event)"
                    (erasingStarted)="erasingStarted()"
                    [active]="eraserActive"></app-eraser>

        <div *ngIf="isImageLoaded">
          <app-signature class="noselect"
                         *ngFor="let sgn of page?.imageSignatures; index as i;"
                         [element]="sgn"
                         [scale]="scale"
                         id="sig_{{i}}"
                         [clientMode]="clientMode"
                         [draggable]="false"
                         [selected]="sgn.selected"
                         [pageModifiedPosition]="pageModifiedPosition"
                         [pageModified]="pageModifiedElement"
                         (pageModifiedReset)="pageModifiedReset($event)"
                         (onScaleChanged)="onSelectedImageSignatureScaleChanged()"
                         (onStyleChanged)="onSelectedSignatureStyleChanged()"
                         (mousedown)="selectImgSignature('sig_'+i)"
                         (touchstart)="selectImgSignature('sig_'+i)"></app-signature>
        </div>
        <div *ngIf="isImageLoaded">
          <app-pen-marker *ngFor="let pmk of page?.markers; index as i;"
                          [element]=pmk
                          class="noselect"
                          id="pmk_{{i}}"
                          [draggable]="false"
                          [canvasClass]="'abx-element'"
                          [pageElement]="true"
                          [selected]="pmk.selected"
                          [pageModifiedPosition]="pageModifiedPosition"
                          [pageModified]="pageModifiedElement"
                          (pageModifiedReset)="pageModifiedReset($event)"
                          (mousedown)="selectPmk('pmk_'+i)"
                          (touchstart)="selectPmk('pmk_'+i)"></app-pen-marker>
        </div>
        <div *ngIf="isImageLoaded">
          <app-text *ngFor="let txt of page?.texts; index as i;"
                    [element]="txt"
                    [draggable]="false"
                    [scale]="scale"
                    id="txt_{{i}}"
                    (onEnter)="enterInTextElement('txt_'+i)"
                    [pageModifiedPosition]="pageModifiedPosition"
                    (onTextChanged)="onSelectedTextChanged()"
                    (onLetterSpacingChangeStart)="onSelectedTextLetterSpacingChangeStart()"
                    (onLetterSpacingChange)="onSelectedTextLetterSpacingChange()"
                    (onLetterSpacingChangeEnd)="onSelectedTextLetterSpacingChangeEnd()"
                    [pageModified]="pageModifiedElement"
                    [selected]="txt.selected"
                    (pageModifiedReset)="pageModifiedReset($event)"
                    (click)="selectText('txt_'+i)"></app-text>
        </div>

        <app-select-point class="editor-component"
                          *ngIf="isImageLoaded"
                          [ngStyle]="selectPointStyle"
                          [active]="selectPointActive"
                          (selectPoint)="selectPoint($event)"></app-select-point>

        <app-select-crop-points class="editor-component"
                                *ngIf="isImageLoaded"
                                [ngStyle]="cropStyle"
                                [initialPoints]="cropPoints"
                                [active]="cropActive"
                                [scale]="scale"
                                [container]="'background'"
                                (selectPoints)="updateCropPoints($event)"
                                (cancelSelection)="cancelCropPoints()"></app-select-crop-points>
      </div>

    </div>
    <div id="elementMover" draggable="false" style="position: absolute; left: 0px; top: 0px;" [hidden]="(selectedId == '')" (click)="handlePageClick(undefined)" (contextmenu)="handlePageClick(undefined)">

      <!-- Element mover -->
      <div id="elementMoverButtonsContainer" draggable="false">
        <div id="elementMoverCursor"
             draggable="false">
          <span class="elementMoverCursor"></span>
        </div>
        <div id="elementScalePlusButton"
             draggable="false"
             [hidden]="!(selectedImgSignature !== undefined || selectedText !== undefined || (selectedMarker !== undefined && selectedMarker?.elementIdentificator === 7))"
             (click)="scaleSelection(1)">
          <span [ngClass]="(selectedText !== undefined ? 'elementFontScalePlusButton' : 'elementScalePlusButton')"></span>
        </div>
        <div id="elementScaleMinusButton"
             draggable="false"
             [hidden]="!(selectedImgSignature !== undefined || selectedText !== undefined || (selectedMarker !== undefined && selectedMarker?.elementIdentificator === 7))"
             (click)="scaleSelection(-1)">
          <span [ngClass]="(selectedText !== undefined ? 'elementFontScaleMinusButton' : 'elementScaleMinusButton')"></span>
        </div>
        <div id="elementActivateLetterSpacing"
             draggable="false"
             [hidden]="!(selectedText !== undefined && selectedText?.letterSpacing === 0)"
             (click)="activateLetterSpacing()">
          <span class="elementFontActivateLetterSpacingButton"></span>
        </div>
        <div id="elementDeactivateLetterSpacing"
             draggable="false"
             [hidden]="!(selectedText !== undefined && selectedText?.letterSpacing !== 0)"
             (click)="deactivateLetterSpacing()">
          <span class="elementFontDeactivateLetterSpacingButton"></span>
        </div>
        <div id="elementDeleteButton"
             draggable="false"
             (click)="deleteSelection(); stopEditingCurrentElement();">
          <span class="elementDeleteButton"></span>
        </div>
      </div>

      <!-- Image/Image signature resizer -->
      <div id="elementResizer" style="position: absolute; left: 0px; top: 0px;" [hidden]="!(selectedId != '' && !cropActive && selectedImgSignature !== undefined)">
        <span id="image-resizer-controller" class="image-resize-controller abx-donot-dragndrop"></span>
      </div>

    </div>
  </div>
</div>

<!-- Download contextual menu -->
<ul id="download-contextual-menu"  class="dropdown-menu contextual-dropdown-menu" [ngStyle]="contextualMenuStyle" *ngIf="!clientMode" (contextmenu)="handleContextualMenuClick($event)">
  <li class="abx-dropdown-menu-item" *ngIf="!clientMode"><a href="javascript:void(0)" class="dropdown-item" (click)="addPenMarker(penMakerPoints, mode);checkSubscriptionAndDownload('pdf', false, false, -1)">{{'DownloadPDF' | translate}}</a></li>
  <li class="abx-dropdown-menu-item" *ngIf="!clientMode"><a href="javascript:void(0)" class="dropdown-item" (click)="addPenMarker(penMakerPoints, mode);checkSubscriptionAndDownload('pdf', true, false, -1)">{{'PerformOCRAndDownloadPDF' | translate}}</a></li>
  <li class="abx-dropdown-menu-item" *ngIf="!clientMode"><a href="javascript:void(0)" class="dropdown-item" (click)="addPenMarker(penMakerPoints, mode);checkSubscriptionAndDownload('png', false, false, currentPageNo)">{{'ExportPageAsPNG' | translate}}</a></li>
  <li class="abx-dropdown-menu-item" *ngIf="!clientMode"><a href="javascript:void(0)" class="dropdown-item" (click)="addPenMarker(penMakerPoints, mode);checkSubscriptionAndDownload('pdf', false, true, -1)">{{'PrintPDF' | translate}}</a></li>
  <li class="abx-dropdown-menu-item abx-dropdown-divider" *ngIf="!clientMode"></li>
  <li class="abx-dropdown-menu-item" *ngIf="!clientMode"><a href="javascript:void(0)" class="dropdown-item" (click)="saveAndDownload('swrd')">{{'DownloadSWRD' | translate}}</a></li>
  <li class="abx-dropdown-menu-item" *ngIf="clientMode && showDownButton"><a href="{{clientDownloadPDFLink}}" class="dropdown-item" target="_blank">{{'DownloadPDF' | translate}}</a></li>
</ul>
<!-- End of downloadd contextual menu-->


<div [attr.inert]="beInert()" *ngIf="isImageLoaded" class="toolbar-bottom" [hidden]="!(pageIsPositioned && pageIsLoaded)">

  <!-- PREVIOUS / NEXT BUTTONS -->
  <button title="{{'PreviousPage' | translate}}" *ngIf="clientMode" (click)="addPenMarker(penMakerPoints, mode);clientGoPrevPage()" class="btn btn-default" [disabled]="clientCurrentPage <= 1"><i class="toolbar-icon ic-back"></i><span class="d-none d-md-inline-block"> {{'PreviousPage' | translate}}</span></button>
  <button title="{{'PreviousPage' | translate}}" *ngIf="!clientMode" [disabled]="!prevPage" (click)="addPenMarker(penMakerPoints, mode);gotoNextPage(false)" class="btn btn-default"><i class="toolbar-icon ic-back"></i><span class="d-none d-md-inline-block"> {{'PreviousPage' | translate}}</span></button>

  <button title="{{'DeletePage' | translate}}" *ngIf="!clientMode" [disabled]="!(prevPage || nextPage)" (click)="askDeletePage()" class="btn btn-default btn-border-right d-none d-md-inline-block d-lg-inline-block"><i class="toolbar-icon ic-page-delete"></i></button>
  <button title="{{'ZoomOut' | translate}}" (click)="zoom(-1)" class="btn btn-default"><i class="toolbar-icon ic-zoom-out"></i></button>

  <button class="btn btn-default pagesSelector" title="{{ 'SelectPage' | translate }}" *ngIf="clientMode" (click)="togglePageSelector();">
    <span>{{ clientCurrentPage }}</span>/<span>{{ clientPageCount }}</span>
  </button>
  <button class="btn btn-default pagesSelector" title="{{ 'SelectPage' | translate }}" *ngIf="!clientMode" (click)="togglePageSelector();">
    <span>{{ currentPageNo }}</span>/<span>{{ pageCount }}</span>
  </button>

  <button title="{{'ZoomIn' | translate}}" (click)="zoom(1)" class="btn btn-default"><i class="toolbar-icon ic-zoom-in"></i></button>
  <button title="{{'InsertPages' | translate}}" *ngIf="!clientMode" (click)="addPenMarker(penMakerPoints, mode);fileInput.click()" class="btn btn-default btn-border-left d-none d-md-inline-block d-lg-inline-block"><i class="toolbar-icon ic-page-add"></i></button>

  <button title="{{'NextPage' | translate}}" *ngIf="clientMode" (click)="addPenMarker(penMakerPoints, mode);clientGoNextPage()" class="btn btn-default" [disabled]="clientCurrentPage >= clientPageCount"><span class="d-none d-md-inline-block">{{'NextPage' | translate}} </span><i class="toolbar-icon ic-forward"></i></button>
  <button title="{{'NextPage' | translate}}" *ngIf="!clientMode" [disabled]="!nextPage" (click)="addPenMarker(penMakerPoints, mode);gotoNextPage(true)" class="btn btn-default"><span class="d-none d-md-inline-block">{{'NextPage' | translate}} </span><i class="toolbar-icon ic-forward"></i></button>

</div>

<input [attr.inert]="beInert()" class="form-control d-none" type="file" id="fileInput" #fileInput (change)="uploadFileFromFileInput($event)" />

<div [attr.inert]="beInert()" *ngIf="isImageLoaded" class="pageSelectorInput" [hidden]="!(showPageSelector)">
  <div id="pageSelectorTitle">{{'GoToPageNumber' | translate}}:</div>
  <input [ngModelOptions]="{standalone: true}" [(ngModel)]="jumpToPage" ng-keyup="handleKeyPressOnPageSelector($event.keyCode);" type="number" id="pageSelectorInput" />
  <div class="d-flex justify-content-around">
    <button class="scanwritr-btn" title="{{'OK' | translate}}" (click)="addPenMarker(penMakerPoints, mode);goToPage(jumpToPage);">{{'OK' | translate}}</button>
    <button class="scanwritr-btn" title="{{'Cancel' | translate}}" (click)="closePageSelector();">{{'Cancel' | translate}}</button>
  </div>
</div>

<div id="pageLoaderDiv" *ngIf="(showLoader || !pageIsPositioned || !pageIsLoaded)" [ngClass]="(showLoader || !pageIsPositioned || !pageIsLoaded ? 'page-loader' : 'page-loader page-loader-invisible')">
  <div class="centered-div-outer">
    <div class="centered-div-middle">
      <div class="centered-div-inner opening-page">
        <div class="loadingFileSpinner"></div>
        <div>{{loaderMessage}}…</div>
      </div>
    </div>
  </div>
</div>

<div id="downloadDiv" class="dialog-background" *ngIf="showSubscriptionDialog" (click)="doHideSubscriptionDialog();">
  <div class="dialog" (click)="$event.stopPropagation();">
    <div class="close" (click)="doHideSubscriptionDialog();"></div>
    <div class="title" *ngIf="storereason === UPGRADE_DOWNLOAD_SEARCHABLE_PDF">{{'DownloadSearchablePDF' | translate}}</div>
    <div class="title" *ngIf="storereason === UPGRADE_DOWNLOAD_PDF">{{'DownloadPDFOrExportPNG' | translate}}</div>
    <div class="title" *ngIf="storereason === UPGRADE_USE_ERASER">{{'Eraser' | translate}}</div>
    <hr />
    <div class="upgrade-desc">
      <div>{{'UpgradeAndDownloadPDFDesc' | translate }}</div>
      <div>{{'UpgradeAndDownloadPDFDesc2' | translate }}</div>
    </div>
    <hr />

    <!-- Buttons for download -->
    <div class="upgrade-buttons" *ngIf="storereason === UPGRADE_DOWNLOAD_SEARCHABLE_PDF || storereason === UPGRADE_DOWNLOAD_PDF">
      <button class="btn btn-default btn-primary btn-with-icon btn-icon-upgrade"
              id="upgradeAndDownload"
              (click)="doShowUpgradeOptions(storereason);">
        <b>
          <span *ngIf="downloadPDFWithOCR">{{'UpgradeAndDownloadSearchablePDF' | translate}}</span>
          <span *ngIf="!downloadPDFWithOCR">{{'UpgradeAndDownloadPDFOrExportPNG' | translate}}</span>
        </b>
      </button>
    </div>

    <!-- Button for eraser -->
    <div class="upgrade-buttons" *ngIf="storereason === UPGRADE_USE_ERASER">
      <button class="btn btn-default btn-primary btn-with-icon btn-icon-upgrade"
              id="upgradeAndUseEraser"
              (click)="doShowUpgradeOptions(storereason);">
        <b>
          <span>{{'UpgradeAndStartUsingEraser' | translate}}</span>
        </b>
      </button>
    </div>

    <div *ngIf="!userId">
      <hr />
      <div id="alreadyHaveSubscriptionQ">
        {{'AlreadyHaveSubscriptionQ' | translate}}<br />
        <a href="javascript:void(0)" (click)="startSignIn((storereason === UPGRADE_USE_ERASER ? AFTER_SIGNIN_START_ERASER_TOOL : AFTER_SIGNIN_DOWNLOAD_PDF));">{{'SignInWithSubscriptionAccount' | translate}}</a>
      </div>
    </div>

    <!-- Mobile Apps Description -->
    <hr />
    <div class="notifyMobileApps">
      <div class="mobileAppBadges">
        <div>{{ 'UpgradeAndGetMobileAppsDesc' | translate }}</div>
        <a href="https://apps.apple.com/us/app/scanwritr/id641480804" target="_blank"><img src="./images/badges/apple-app-store-badge.svg" /></a>
        <a href="https://play.google.com/store/apps/details?id=com.vanaia.scanwritr" target="_blank"><img src="./images/badges/google-play-badge.png" /></a>
      </div>
    </div>
  </div>
</div>

<div id="upgradeOptions" class="dialog-background dialog-background-gray" *ngIf="showUpgradeOptions" (click)="doHideUpgradeOptionsDialog();">
  <div class="dialog dialog-wide dialog-subscribe {{ (subscriptionInfo?.sku ? 'dialog-upgrade' : '') }}" (click)="$event.stopPropagation();">
    <div class="close close-invert" (click)="doHideUpgradeOptionsDialog();"></div>

    <div *ngIf="subscriptionInfo && updatingSubscriptionInfo == false">
      <div class="title dialog-title" *ngIf="(currentlyOpenedUpgradeWindowReason != UPGRADE_USE_ERASER && currentlyOpenedUpgradeWindowReason != UPGRADE_DOWNLOAD_SEARCHABLE_PDF)">{{'SubscribeTitle-' + (subscriptionInfo?.sku ? subscriptionInfo?.sku : '') | translate }}</div>
      <div class="title dialog-title" *ngIf="!(subscriptionInfo.sku) && !(currentlyOpenedUpgradeWindowReason != UPGRADE_USE_ERASER && currentlyOpenedUpgradeWindowReason != UPGRADE_DOWNLOAD_SEARCHABLE_PDF)">{{'SubscribeTitle-pro-only' | translate }}</div>
      <div class="title dialog-title" *ngIf=" (subscriptionInfo.sku) && !(currentlyOpenedUpgradeWindowReason != UPGRADE_USE_ERASER && currentlyOpenedUpgradeWindowReason != UPGRADE_DOWNLOAD_SEARCHABLE_PDF)">{{'SubscribeTitle-pro-only-upgrade' | translate }}</div>

      <div class="subtitle dialog-subtitle" *ngIf="subscriptionInfo?.sku">
        <span *ngIf="subscriptionInfo.has_at_least_one_yearly_upgrade">{{ 'Subscribtion-upgrade-maximize' | translate }}</span>
        <span *ngIf="subscriptionInfo.discount_formatted">{{ 'Subscribtion-we-ll-apply' | translate }}</span>
        <span *ngIf="subscriptionInfo.discount_formatted"><b>{{ subscriptionInfo.discount_formatted }} {{ 'Subscribtion-deduction' | translate }}</b></span>
        <span *ngIf="subscriptionInfo.discount_formatted">{{ 'Subscribtion-towards-you-first-upgrade' | translate }}</span>
      </div>
    </div>

    <!-- Progress bar -->
    <div class="loading-available-upgrades" *ngIf="!(subscriptionInfo && updatingSubscriptionInfo == false)">
      <div class="loadingFileSpinner"></div>
    </div>

    <!-- Available subscriptions -->
    <div class="upgrade-options-list" *ngIf="subscriptionInfo && updatingSubscriptionInfo == false">
      <div class="upgrade-option" *ngFor="let upg of subscriptionInfo?.packages; index as i;" [ngClass]="(!(upg?.is_export && (currentlyOpenedUpgradeWindowReason == UPGRADE_USE_ERASER || currentlyOpenedUpgradeWindowReason == UPGRADE_DOWNLOAD_SEARCHABLE_PDF)) ? '' : 'upgrade-option-display-none')">
        <!--<div *ngIf="!(upg?.is_export && (currentlyOpenedUpgradeWindowReason == UPGRADE_USE_ERASER || currentlyOpenedUpgradeWindowReason == UPGRADE_DOWNLOAD_SEARCHABLE_PDF))">-->
          <div class="upgrade-title-and-subtitle {{ subscriptionInfo?.sku ? 'small-min-height' : '' }}">

            <!-- Subscription title -->
            <div *ngIf="upg?.is_daily_pro" class="title title-daily-pro">{{ 'SubscribtionTitle-single-day-pro' | translate }}</div>
            <div *ngIf="upg?.is_export" class="title title-export">{{ 'SubscribtionTitle-export' | translate }}</div>
            <div *ngIf="upg?.is_pro" class="title title-pro">{{ 'SubscribtionTitle-pro' | translate }}</div>

            <!-- Subscription type -->
            <div *ngIf="upg?.is_daily_pro" class="subtitle subtitle-daily-pro">{{ 'SubscribtionSubTitle-single-day-pro' | translate }}</div>
            <div *ngIf="upg?.is_export" class="subtitle subtitle-export">{{ 'SubscribtionSubTitle-export' | translate }}</div>
            <div *ngIf="upg?.is_pro" class="subtitle subtitle-pro">{{ 'SubscribtionSubTitle-pro' | translate }}</div>

            <!-- Separator -->
            <div class="upgrade-title-separator"></div>

          </div>

          <!-- Bullets -->
          <div class="upgrade-bullets">
            <div class="upgrade-option-bullet">{{ 'Subscription-upgrade-bullet-export-to-pdf' | translate }}</div>
            <div class="upgrade-option-bullet" *ngIf="upg?.is_daily_pro || upg?.is_pro">{{ 'Subscription-upgrade-bullet-ocr' | translate }}</div>
            <div class="upgrade-option-bullet" *ngIf="upg?.is_daily_pro || upg?.is_pro">{{ 'Subscription-upgrade-bullet-eraser' | translate }}</div>
            <div class="upgrade-option-bullet" *ngIf="upg?.is_daily_pro || upg?.is_pro">{{ 'Subscription-upgrade-bullet-unlock-apps' | translate }}</div>
          </div>

          <!-- Store icons -->
          <div class="upgrade-store-icons" *ngIf="upg?.is_daily_pro || upg?.is_pro">
            <a href="https://play.google.com/store/apps/details?id=com.vanaia.scanwritr" target="_blank"><img src="./images/icons/store-google-play.png" /></a>
            <a href="https://apps.apple.com/us/app/scanwritr/id641480804" target="_blank"><img src="./images/icons/store-apple.png" /></a>
            <a href="https://apps.microsoft.com/detail/9wzdncrdj2b1" target="_blank"><img src="./images/icons/store-ms.png" /></a>
          </div>

          <!-- Flex area between content of the product and buy buttons -->
          <div class="flex-1"></div>


          <div class="upgrade-buttons-wrapper">

            <!-- Buy -- top button - yearly -->
            <div class="upgrade-btn-wrapper">
              <div *ngIf="upg?.pricing[0].sku != ''"
                   class="upgrade-btn upgrade-btn-first upgrade-btn-with-three-lines"
                   (click)="startPurchaseProcess(upg?.pricing[0].sku, upg?.pricing[0].fs_payload, upg.pricing[0].fs_key);">
                <div>
                  <span>{{ 'Subscription-upgrade-yearly' | translate }}</span>
                  <span><b> {{ 'Subscription-upgrade-yearly-save' | translate: { save: upg?.pricing[0].save_percent_formatted } }}</b></span>
                </div>
                <div class="upgrade-price-label-wrapper">
                  <span>{{ upg?.pricing[0].price_m_formatted }} {{ 'Subscription-upgrade-per-month-suffix' | translate }}</span>
                </div>
                <div *ngIf="upg?.pricing[0].discount == 0">
                  <!-- Billed info if no discount is available -->
                  <span>{{ 'Subscription-upgrade-billed-yearly-at' | translate }}</span>
                  <span><b> {{ upg?.pricing[0].price_y_formatted }}</b></span>
                </div>
                <div *ngIf="upg?.pricing[0].discount > 0">
                  <!-- Billed yearly info with discount -->
                  <span class="semibold-price-info">{{ 'Subscription-upgrade-billed-yearly' | translate }}</span>
                  <span class="full-strikethrough-price"> {{ upg?.pricing[0].price_y_formatted }}</span>
                  <span class="semibold-price-info"> {{ upg?.pricing[0].price_with_discount_formatted }}.</span>
                  <span class="semibold-price-info"> {{ upg?.pricing[0].discount_formatted }}</span>
                  <span class="semibold-price-info"> {{ 'Subscription-upgrade-off-first-year' | translate }}.</span>
                </div>
              </div>
            </div>

            <!-- Buy -- bottom button - monthly/for a day -->
            <div class="upgrade-btn-wrapper">
              <div *ngIf="upg?.pricing[1].sku != ''"
                   class="upgrade-btn upgrade-btn-second {{ upg?.pricing[1].discount > 0 ? 'upgrade-btn-with-three-lines' : 'upgrade-btn-with-two-lines' }} {{ upg?.is_daily_pro ? 'upgrade-btn-daily-pro' : '' }}"
                   (click)="startPurchaseProcess(upg?.pricing[1].sku, upg?.pricing[1].fs_payload, upg.pricing[1].fs_key);">
                <div>
                  <span *ngIf="upg?.is_daily_pro == false">{{ 'Subscription-upgrade-monthly' | translate }}</span>
                  <span *ngIf="upg?.is_daily_pro == true"> {{ 'Subscription-upgrade-get-for-a-day' | translate }}</span>
                </div>
                <div class="upgrade-price-label-wrapper">
                  <span *ngIf="upg?.is_daily_pro == false">{{ upg?.pricing[1].price_m_formatted }} {{ 'Subscription-upgrade-per-month-suffix' | translate }}</span>
                  <span *ngIf="upg?.is_daily_pro == true"> {{ upg?.pricing[1].price_with_discount_formatted }}</span>
                </div>
                <div *ngIf="upg?.pricing[1].discount > 0">
                  <!-- Billed monthly info with discount -->
                  <span class="semibold-price-info">{{ 'Subscription-upgrade-billed' | translate }}</span>
                  <span class="semibold-price-info"> {{ upg?.pricing[1].price_with_discount_formatted }}</span>
                  <span class="semibold-price-info"> {{ 'Subscription-upgrade-first-month' | translate }}.</span>
                  <span class="semibold-price-info"> {{ upg?.pricing[1].discount_formatted }}</span>
                  <span class="semibold-price-info"> {{ 'Subscription-upgrade-off-first-month' | translate }}.</span>
                </div>
              </div>
            </div>
          </div>
          <!-- PREVERI: [attr.inert]="upg?.is_daily_pro ? true : undefined " -->
          <div class="auto-renewal-cancellation-notice {{ upg.is_daily_pro ? 'invisible-inert' : '' }}" [attr.inert]="upg?.is_daily_pro ? true : undefined ">
            <span>{{ 'Subscription-upgrade-cancellation-info' | translate }}</span>
          </div>
      </div>
    </div>
  </div>
</div>

<div id="chooseOCRLang" class="dialog-background" *ngIf="showChooseOCRLang" (click)="doHideChooseOCRLangDialog();">
  <div class="dialog" (click)="$event.stopPropagation();">
    <div *ngIf="!showChooseOCRLangProgress">
      <div class="close" (click)="doHideChooseOCRLangDialog();"></div>
      <div class="title">{{'ChooseLanguage' | translate}}</div>
      <hr />
      <div class="dialog-desc">{{'ChooseLanguageDesc' | translate }}</div>
      <div id="langList">
        <table>
          <tr *ngFor="let item of OCRLangs; index as i">
            <td>
              <input [disabled]="!item.selected && noMoreOCRLanguages" class="lang-checkbox {{ (item.selected ? 'lang-checkbox-selected' : '') }}" type="checkbox" id="chkLang{{ i }}" [ngModelOptions]="{standalone: true}" [(ngModel)]="item.selected" (ngModelChange)="OCRLangSelectionChanged()" />
            </td>
            <td><label for="chkLang{{ i }}">{{ item.name }}</label></td>
          </tr>
        </table>
      </div>
      <div class="dialog-desc-warning" *ngIf="showNoOCRLangWarning">{{'NoOCRLanguagesSelectedDesc' | translate }}</div>
      <div class="dialog-desc-info" *ngIf="!showNoOCRLangWarning">{{'YouChooseTheFollowingOCRLanguages' | translate }}: <b>{{ selectedOCRLanguages }}</b></div>
      <button [hidden]="!(!showNoOCRLangWarning)" (click)="startDownloadPDFWithOCR();">{{'DownloadSearchablePDF' | translate }}</button>
    </div>
    <div *ngIf="showChooseOCRLangProgress">
      <div class="loadingFileSpinner"></div>
    </div>
  </div>
</div>

<div id="waitingForConfirmation" class="page-loader page-loader-wide" *ngIf="showWaitingForSubscription">
  <div class="centered-div-outer">
    <div class="centered-div-middle">
      <div class="centered-div-inner opening-page">
        <div class="loadingFileSpinner"></div>
        <div>{{'WaitingForConfirmationDescription' | translate}}…</div>
      </div>
    </div>
  </div>
</div>

<div id="waitingForConfirmation" class="page-loader page-loader-wide order-confirmation" *ngIf="showThankYouForSubscribing">
  <div class="centered-div-outer">
    <div class="centered-div-middle">
      <div class="centered-div-inner opening-page">
        <div class="order-confirmation-check-img"></div>
        <div>{{'OrderConfirmation' | translate}}</div>
        <button class="btn btn-primary" (click)="showThankYouForSubscribing = false;">{{'OK' | translate}}</button>
      </div>
    </div>
  </div>
</div>

